import { render, staticRenderFns } from "./PrivacyChoiceSection.vue?vue&type=template&id=6a93a13a&scoped=true"
import script from "./PrivacyChoiceSection.vue?vue&type=script&lang=js"
export * from "./PrivacyChoiceSection.vue?vue&type=script&lang=js"
import style0 from "./PrivacyChoiceSection.vue?vue&type=style&index=0&id=6a93a13a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a93a13a",
  null
  
)

export default component.exports